<!--  -->
<template>
  <div class="domainName-list-box">
    <div class="action-bar">
      <!--操作栏-->
      <div class="action-bar">
        <el-input
          size="small"
          clearable
          placeholder="商区码"
          v-model="params.districtCode"
          @change="getDomainList('status')"
          class="param-input"
        />
        <el-input
          size="small"
          clearable
          placeholder="域名"
          v-model="params.domainName"
          @change="getDomainList('status')"
          class="param-input"
        />
        <el-button type="primary" size="small" @click="getDomainList('status')">搜索</el-button>
        <el-button type="primary" size="small" @click="addDomain('add')">新增</el-button>
      </div>
      <!--数据表格-->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="districtCode" label="商区码" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.districtCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="promSeqe" label="序列号" align="center" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.promSeqe }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="domainName" label="域名" align="center" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.domainName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="addDomain('edit',scope.row)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="remove(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-pagination
        :page-sizes="[10, 15, 20, 25]"
        :current-page="params.pageNumber"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        v-if="total > 10"
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
      <!--新增、编辑申请广告弹窗-->
      <edit-page ref="editPage" @handlerAgentList="handlerAgentList"></edit-page>
    </div>
    <div class="zw"></div>
  </div>
</template>

<script>
import API from "@/api";
// import { changeTime } from "@/utils/global";
import EditPage from "./components/editPage";
export default {
  data() {
    return {
      isDed: false,
      //服务器响应参数:
      total: 0,
      list: [],
      // dialogVisible: false,
      tableData: [], //Table表显示数据
      loading: false,
      // 请求列表参数
      params: {
        pageNumber: 1, //required
        pageSize: 10, //required
      },
    };
  },
  created() {
    this.getDomainList();
  },
  components: {
    EditPage,
  },
  methods: {
    // 请求域名列表
    getDomainList() {
      this.params.pageNumber = 1;
      this.loading = true;
      API.getDomainList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list.length !== 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handlerAgentList() {
      this.getDomainList();
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getDomainList();
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getDomainList();
    },
    // 新增、修改域名
    addDomain(type, data) {
      this.$refs.editPage.open(type, data);
    },
    //删除域名
    remove(id) {
      this.$confirm("您确定要删除这条域名信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.delDomain({ id: id }).then((res) => {
          if (res.code === 200) {
            this.getDomainList();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
  },
};
</script>

<style lang="" scoped></style>
